/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Images
import eventDefault from "assets/images/defaults/event_default.jpg";
import { notificationActions } from "../../../../../../store/notification/notification-slice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import initialValues from "../../schemas/initialValues";



function EventImage({ value, setFieldValue }) {
  const [uploadCover, setUploadCover] = useState(null);

  const dispatch = useDispatch();
  useEffect(()=>{
    if(initialValues["cover"] === value){
      setUploadCover(value);
    } else{
      setUploadCover(URL.createObjectURL(value));
    }
  },[])

  const handleCoverImage = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    const maxAllowedSize = 2 * 1024 * 1024;
    if (e.target.files[0].size > maxAllowedSize) {
      dispatch(notificationActions.showMessage({ message: "File is too big (max 2MB)", variant: "error" }));
    } else {
      setUploadCover(URL.createObjectURL(e.target.files[0]));
      setFieldValue("cover", e.target.files[0]);
    }
  };
  return (
    <Card>
      <MDBox textAlign="center" pt={2} pb={3} px={3}>
        To change the cover image, click the image below.
      </MDBox>
      <MDBox
        position="relative"
        borderRadius="lg"
        mt={-3}
        mx={2}
        className="card-header"
        sx={{ transition: "transform 300ms cubic-bezier(0.34, 1.61, 0.7, 1)" }}
      >
        <input
          accept="image/png, image/jpeg"
          type="file"
          id="user-avatar-file"
          style={{ display: "none" }}
          onChange={handleCoverImage}
        />
        <label htmlFor="user-avatar-file">
        <MDBox
          component="img"
          src={uploadCover}
          alt="Event Cover Image"
          borderRadius="lg"
          shadow="sm"
          width="100%"
          height="100%"
          position="relative"
          zIndex={10}
          mb={2}
        />
        </label>
      </MDBox>

    </Card>
  );
}

export default EventImage;
